// extracted by mini-css-extract-plugin
export var changeIcon = "_42-4";
export var container = "_42-0";
export var divider = "_42-7";
export var externalLinkIcon = "_42-1";
export var green = "_42-5";
export var helpCircleIcon = "_42-3";
export var iconButton = "_42-2";
export var red = "_42-6";